import BaseModel from "../../../../base/baseModel";

export default class InformacoesAdicionaisNfeModel extends BaseModel {
    observacao: string = null;
}
